$(document).ready(function() {
  var questions = [];
  if ($('[diagnostic-questions]').html()) {
    questions = JSON.parse($('[diagnostic-questions]').html());
  }
  var url = window.backend.url;
  var compteur = 1;
  var lastResponse = 'A';
  var percentage = 0;
  var questionsLength = questions.length;
  $('#personnal--data').attr('question-number', questionsLength);
  var initializationInputs = function() {
    for (var i = 0; i < questions.length; i++) {
      var responseInput = $(`<input name="q-${ parseInt(i + 1) }" class="response--input" question-number="${ parseInt(i) }">`);
      $('#diagnostic--inputs').append(responseInput)
    }
  }

  function validatorFunction() {
    // Validators pour les formulaires
    $.validator.messages.required = 'Ce champ est requis.';
    $.validator.messages.email = 'Veuillez entrer une adresse email valide.';
    $.validator.messages.number = 'Vous devez entrer un nombre.';
    $.validator.messages.phoneNumber = 'Vous devez entrer un numéro de téléphone valide.';

    $.validator.addMethod("firstName", function(value, element) {
      var regexResult = value.match(/^[a-zA-Z àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ-]+$/);
      return regexResult ? true : false;
    }, "Merci d'entrer un prénom valide.");

    $.validator.addMethod("birthday", function(value, element) {
      var regexResult = value.match(/^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/);
      if (!value) {
        regexResult = true;
      }
      return regexResult ? true : false;
    }, "Veuillez entrer une date valide au format JJ/MM/AAAA.");

    $.validator.addMethod("checkbox", function(value, element) {
      return $('#newsletter--diag').is(':checked');
    }, "Vous devez accepter l'inscription à la newsletter pour valider et recevoir vos résultats.");
  }


  // fonction qui permet de valider des champs specifiques
  var validateFormTunnel = function() {
    var validator = $("#diagnostic--form").validate({
      rules: {
        "email": {
          "required": true,
          "email": true
        },
        "date_de_naissance": {
          "required": true,
          "birthday": true
        },
        "prenom": {
          "required": true,
          "firstName": true
        }
      }
    })
    validatorFunction()
    validator.element(".response--data");
    var result = validator.form();
    return result;
  }

  // Account forms
  $('body').on('keyup keypress', '.birthday--input', function(event) {
    var inputLength = event.target.value.length;
    var code = event.keyCode || event.which;
    if((inputLength === 2 || inputLength === 5) && code != 8 ){
      var thisVal = event.target.value;
      thisVal += '/';
      $(event.target).val(thisVal);
    }
  })

  $('body').on('keyup keypress', '.diag--email', function(event) {
    var thisVal = event.target.value.toLowerCase().trim();
    $(event.target).val(thisVal);
  })

  initializationInputs();

  var createQuestion = function(questionNumber, type) {
    var questionClasses = "question--container active center-screen";
    if (type == "next") {
      questionClasses = "center-to-right-screen question--container"
    } else if (type == "prev") {
      questionClasses = "center-to-left-screen question--container"
    }

    var responses = $(`.response--input[question-number=${ questionNumber }]`).val();
    var fieldset = $(`<fieldset question-number="${ parseInt(questionNumber) }" id="question-${ parseInt(questionNumber + 1) }" class="${ questionClasses }"></fieldset>`);
    var questionDiv = $(`<div class="question"><span class="question--compteur">${ compteur }.</span>${ questions[questionNumber].question }</div>`);
    var descriptionDiv = $(`<div class="description">${ questions[questionNumber].description }</div>`);


    var responsesDiv;
    var customClass = questions[questionNumber].customClass ? questions[questionNumber].customClass : "";

    if (questions[questionNumber].type == "data") {
      var active = $(`.response--input[question-number=${ questionNumber }]`).val() ? "active" : "";
      var inputType = questions[questionNumber].inputType ? questions[questionNumber].inputType : "text"
      responsesDiv = $(`<input class="input--form input--diag response--data ${ active } ${ customClass }" name="${ questions[questionNumber].name }" type="${ inputType }" placeholder="${ questions[questionNumber].placeholder }" question-number="${ parseInt(questionNumber) }" value="${ $(`.response--input[question-number=${ questionNumber }]`).val() }" >`);
    } else if (questions[questionNumber].type == "information") {
      responsesDiv = $(`<div class="information--container">
      <p class="text__center h1--serif fw--700">${ questions[questionNumber].titre }</p>
      ${ questions[questionNumber].description ? '<p class="text__center h1--body fw--500">' + questions[questionNumber].description + '</p>' : '' }
      </div>`);
      $('.directional--button').addClass('display__none--imp');
    } else if (questions[questionNumber].type == "question_picto") {
      responsesDiv = $(`<ul class="responses responses-picto"></ul>`);
      for (var j = 0; j < questions[questionNumber].responses.length; j++) {
        var activeClass = responses.indexOf(questions[questionNumber].responses[j].code) > -1 ? "active" : "";
        var exclusive = questions[questionNumber].responses[j].exclusive ? "exclusive--true" : "";
        var responseDiv = $(`<li class="response ${activeClass} ${exclusive}" question-number="${ parseInt(questionNumber) }" response-code="${ questions[questionNumber].responses[j].code }">
            <img class="diag--picto" src="${ questions[questionNumber].responses[j].picto }" />
            <span class="text__left width--100">${ questions[questionNumber].responses[j].choice }</span>
          </li>`);
        responsesDiv.append(responseDiv);
      }
    } else {
      responsesDiv = $(`<ul class="responses"></ul>`);
      for (var j = 0; j < questions[questionNumber].responses.length; j++) {
        var activeClass = responses.indexOf(questions[questionNumber].responses[j].code) > -1 ? "active" : "";
        var exclusive = questions[questionNumber].responses[j].exclusive ? "exclusive--true" : "";
        var responseDiv = $(`<li class="response ${activeClass} ${exclusive}" question-number="${ parseInt(questionNumber) }" response-code="${ questions[questionNumber].responses[j].code }">${ questions[questionNumber].responses[j].choice }</li>`);
        responsesDiv.append(responseDiv);
      }
    }

    if (questions[questionNumber].type == "information") {
      fieldset.append(responsesDiv)
    } else {
      fieldset.append(questionDiv)
      fieldset.append(descriptionDiv)
      fieldset.append(responsesDiv)
    }

    $('#personnal--data').before(fieldset);
    // Informations utiles pour les slides avec info
    $('.question--container').attr('type', questions[questionNumber].type);
    $('.question--container').attr('transition-duration', questions[questionNumber].duration);

    // Si on a des champs information avec du contenu qui depend d autres reponses
    if (questions[questionNumber].type == "information") {
      if (questions[questionNumber].conditionalData != undefined) {
        setTimeout(function() {
          var inputValue = $(`.response--input[question-number="${ questions[questionNumber].conditionalData }"]`).val();
          $(`.conditionnal-data[name="${ questions[questionNumber].conditionalData }"]`).text(inputValue)
        }, 1200);

      }
    }
  }

  createQuestion(0);

  // =======================================================================================
  // Le client sélectionne une reponse
  // =======================================================================================
  $('body').on('click', '.response', function() {
    var questionNumber = parseInt($(this).attr('question-number'));
    $('.error--message').addClass('display__none');

    if ($( this ).hasClass('active')) {
      $( this ).toggleClass('active');
    } else {
      var choiceNumber = questions[questionNumber].choice_number;
      var numberActives = $(`.response[question-number=${ questionNumber }].active`).length;
      if (numberActives == choiceNumber) {
        $(`.response[question-number=${ questionNumber }][response-code=${ lastResponse }].active`).removeClass("active");
      }

      // Traite le cas des reponses qui ne peuvent etre cochees que seules
      if ($(this).hasClass('exclusive--true')) {
        $(`.response[question-number=${ questionNumber }].active`).removeClass("active");
      } else {
        $(`.response[question-number=${ questionNumber }].exclusive--true`).removeClass("active");
      }
      lastResponse = $(this).attr('response-code');
      $( this ).addClass('active');
      if (choiceNumber == 1 && questionNumber != (questions.length)) {
        $('.directional--button[type="next"]').click();
      }


    }

    var numberActives = $(`.response[question-number=${ questionNumber }].active`).length;
    var inputValue = "";
    $(`.response[question-number=${ questionNumber }].active`).each(function() {
      inputValue = inputValue + $( this ).attr('response-code') + '-';
    });
    inputValue = inputValue.substring(0, inputValue.length - 1);
    $(`.response--input[question-number=${ questionNumber }]`).val(inputValue);
  })

  $('body').on('change', '.input--diag', function() {
    var questionNumber = parseInt($(this).attr('question-number'));
    var value = $(this).val();
    if (value.length > 0) {
      $(this).addClass('active');
      $('.error--message').addClass('display__none');
    } else {
      $(this).removeClass('active');
    }
    $(`.response--input[question-number=${ questionNumber }]`).val(value);

  })

  // =======================================================================================
  // Gestion du changement de slide
  // =======================================================================================
  // Changer de slide au clic sur entree
  $('body').on('keydown', function (e) {
    var key = e.which;
    if (key == 13) {
      e.preventDefault();
      if ($('#personnal--data').is(':visible')) {
        $('#validate--diagnostic').click();
      } else if ($('.directional--button[type="next"]').is(':visible')) {
        $('.directional--button[type="next"]').click();
      }
    }
  });


  $('.directional--button').on('click', function() {
    var currentQuestion = parseInt($(this).attr('current-question'));
    var personnalQuestion = false;

    if (currentQuestion + 2 == questionsLength + 1) {
      personnalQuestion = true;
      document.dispatchEvent(new CustomEvent('perso-question'));
    } else {
      document.dispatchEvent(new CustomEvent('question-diag', {'detail': { currentQuestion: currentQuestion }}));
    }

    var type = $(this).attr('type');
    var questionType = questions[currentQuestion] ? questions[currentQuestion].type : "";
    var changingQuestion = type == "next" ? (currentQuestion + 1) : (currentQuestion - 1);


    if (questionType == "data") {
      if (type == "prev") {
        for (var j = changingQuestion; j >= 0; j--) {
          if ($(`.response--input[question-number=${ j }]`).val() != "") {
            changingQuestion = j;
            break;
          }
        }
        if (changingQuestion < questionsLength) {
          createQuestion(changingQuestion, type);
        }

        $('.directional--button').attr('current-question', changingQuestion);
        handleTransitionQuestion(currentQuestion, changingQuestion, type, questionType);
      } else {
        var formState = validateFormTunnel();
        if (formState) {
          var conditionnalNumber = handleConditionnalQuestion(currentQuestion);
          changingQuestion = conditionnalNumber ? conditionnalNumber : changingQuestion;

          if (changingQuestion < questionsLength) {
            createQuestion(changingQuestion, type);
          }

          $('.directional--button').attr('current-question', changingQuestion);
          handleTransitionQuestion(currentQuestion, changingQuestion, type, questionType);
        }
      }
    } else {
      if (type == "next" && questions[currentQuestion].required && $('.response').length > 0 && $(`.response[question-number=${ currentQuestion }].active`).length == 0 ) {
        $('.error--message').removeClass('display__none');
      } else {
        if (type == "next" && changingQuestion < questionsLength) {
          var conditionnalNumber = handleConditionnalQuestion(currentQuestion);
          changingQuestion = conditionnalNumber ? conditionnalNumber : changingQuestion;
        } else if (type == "prev") {
          for (var j = changingQuestion; j >= 0; j--) {
            if ($(`.response--input[question-number=${ j }]`).val() != "") {
              changingQuestion = j;
              break;
            }
          }
        }
        if (changingQuestion < questionsLength) {
          createQuestion(changingQuestion, type);
        }

        $('.directional--button').attr('current-question', changingQuestion);
        handleTransitionQuestion(currentQuestion, changingQuestion, type, questionType);
      }
    }
  })

  document.addEventListener('change-question', function (e) {
    if (e.detail.questionType != "information") {
      if (e.detail.type == "prev") {
        compteur -= 1;
        var value = $('.question--container.active .response--input').val();
        if (value == "") {
          $('.directional--button[type="prev"]').click();
          compteur += 1;
        }
      } else {
        compteur += 1;
      }

      handleProgressBarChange();
      $('.question--compteur').text(compteur + '.');
    }

  }, false);

  document.addEventListener('transition-ended', function (e) {
    var currentQuestionType = $('.question--container').attr('type');
    var changingDuration = $('.question--container').attr('transition-duration');

    if (currentQuestionType == "information") {
      setTimeout(function(){
        $('.directional--button').addClass('display__none');
        $('.directional--button').removeClass('display__none--imp');
        $('.directional--button[type="next"]').click();
      }, changingDuration);
    }

  }, false);

  // =======================================================================================
  // Animer le changement de slide
  // =======================================================================================
  var handleTransitionQuestion = function(currentQuestion, changingQuestion, type, questionType) {

    setTimeout(function(){
      $(`#directionnal--container`).addClass('animated');
      var transitionClass = type == "next" ? 'center-to-left-screen' : 'center-to-right-screen';
      var transitionRemoveClass = type == "next" ? 'center-screen center-to-right-screen' : 'center-screen center-to-left-screen';
      $(`.question--container[question-number=${currentQuestion}]`).removeClass(transitionRemoveClass);
      $(`.question--container[question-number=${currentQuestion}]`).addClass(transitionClass);
    }, 350);

    setTimeout(function(){
      if (currentQuestion != questionsLength) {
        $(`.question--container[question-number=${currentQuestion}]`).remove();
      } else {
        $(`.question--container[question-number=${currentQuestion}]`).removeClass("active");
      }

      $(`.question--container[question-number=${changingQuestion}]`).addClass('active');
      document.dispatchEvent(new CustomEvent('change-question', {detail: {type: type, questionType: questionType}}));
    }, 1050);

    setTimeout(function(){
      $(`.question--container[question-number=${changingQuestion}]`).addClass('center-screen');
    }, 1100);
    setTimeout(function(){
      if (changingQuestion == 0) {
        $('.directional--button[type="prev"]').addClass('display__none');
      } else if (changingQuestion == questions.length) {
        $('.directional--button[type="next"]').addClass('display__none');
        $('#validate--diagnostic').removeClass('display__none--imp');
      } else {
        $('.directional--button').removeClass('display__none');
        $('#validate--diagnostic').addClass('display__none--imp');
      }
      $(`#directionnal--container`).removeClass('animated');

      document.dispatchEvent(new CustomEvent('transition-ended', {detail: {currentQuestion: currentQuestion}}));
    }, 1800);
  }

  // =======================================================================================
  // Mise a jour de la barre de progression
  // =======================================================================================
  var handleProgressBarChange = function() {
    var currentQuestion = Math.max(0,parseInt($('.question--container.active').attr('question-number')));
    var percentage = (currentQuestion / (questionsLength + 1)) * 100;
    $('#progress--state').css('width', percentage + '%');
    $('#progress--text').text(Math.trunc(percentage) + '%');
    percentage == 0 ? $('#progress--text').css('left', '10px') : $('#progress--text').css('left', `calc(${percentage}% - 13px)`);
  }

  var handleConditionnalQuestion = function(questionNumber) {
    var conditionnal = questions[questionNumber].conditionnal
    if (conditionnal) {
      var response = $(`.response--input[question-number="${ parseInt(questionNumber) }"]`).val();
      for (var i = 0; i < conditionnal.length; i++) {
        var regex = new RegExp(conditionnal[i].logic)
        if (response.match(regex)) {
          if (conditionnal[i].clear) {
            for (var j = 0; j < conditionnal[i].clear.length; j++) {
              $(`.response--input[question-number=${ conditionnal[i].clear[j] - 1 }]`).val("");
            }
          }
          // -1 car lesquestions sont entrees en base 1 dans le JSON mais base 0 dans le code
          return conditionnal[i].nextQuestion - 1;
        }
      }
    } else {
      return null;
    }
  }

  $('#newsletter--diag-label').on('click', function() {
    $('#newsletter--diag').prop( "checked", !$('#newsletter--diag').is(':checked'));
    $('label.error[for="newsletter"]').text('');
  })

  // =============================================================================
  // Page de chargement
  // =============================================================================
    function updateLoadingBar() {
      $('#progress--state-loading').css('width', '20%');
      setTimeout(function(){
        $('#progress--state-loading').css('width', '25%');
      }, 1500);
      setTimeout(function(){
        $('#progress--state-loading').css('width', '50%');
      }, 2500);
      setTimeout(function(){
        $('#progress--state-loading').css('width', '60%');
      }, 2700);
      setTimeout(function(){
        $('#progress--state-loading').css('width', '80%');
      }, 3100);
      setTimeout(function(){
        $('#progress--state-loading').css('width', '95%');
      }, 4100);
      setTimeout(function(){
        $('#progress--state-loading').css('width', '98%');
      }, 4300);
    }

  // =======================================================================================
  // Validation du diag
  // =======================================================================================
  function validateForm() {
    var validator = $("#diagnostic--form").validate({
      rules: {
       // "date_de_naissance": {
       //    "required": false,
       //    "birthday": true
       // },
       // "prénom": {
       //    "required": true,
       //    "firstName": true
       // },
       "email": {
          "required": true,
          "email": true
       },
       "newsletter": {
          "required": true,
          "checkbox": true
       }
      }
    })
    validatorFunction();

    var result = validator.form();
    if (result == false) {
      $('#validate--diagnostic').children('.button--text').css('display', 'block');
      $('#validate--diagnostic').children('.button--loading').css('display', 'none');
    }
    return result;
  }

  // Custom question
  $('#diagnostic--form').submit(function(e) {
    e.preventDefault();
    var formValidated = validateForm();
    if (formValidated) {
      var serializedArray = $('#diagnostic--form').serializeArray();
      var data = {};

      for (var i = 0; i < serializedArray.length; i++) {
        data[serializedArray[i].name] = serializedArray[i].value;
      }

      $.ajax({
        type: "POST",
        url: url + "diagnostic-beaute",
        data: data,
        success: function(data){
          _learnq.push(['identify', {
            '$email': $('.diag--email').val()
          }]);

          // Cacher les elements
          $('#progress--bar').fadeOut(700);
          $('.formulaire-diagnostic--container').fadeOut(700);
          setTimeout(function(){
            $('#loading--page').show();
          }, 710);

          updateLoadingBar();
          if (window.dataLayer) {
            window.dataLayer.push({
              "event" : "genericEvent",
              "eventCategory" : "engagement",
              "eventAction" : "finishDiagnostic",
              "eventLabel" : "success"
            });
          }
          
          setTimeout(function(){
            document.dispatchEvent(new CustomEvent('validation-succes'));
            window.location.href = `/pages/diagnostic-resultats?email=${data.email}`;
          }, 5000);




        },
        error: function(error){
          // console.log(error)
          // document.dispatchEvent(new CustomEvent('validation-error'));
          // setTimeout(function(){
          //   $('#validate--diagnostic').children('.button--text').css('display', 'block');
          //   $('#validate--diagnostic').children('.button--loading').css('display', 'none');
          //   $('#error--container').text("Votre diagnostic n'a pu être validé. Veuillez réessayer ultérieurement.");
          // }, 1300);
          $('#progress--bar').fadeOut(300);
          $('.formulaire-diagnostic--container').fadeOut(300);
          setTimeout(function(){
            $('#loading--page').show();
          }, 310);
          updateLoadingBar();
          setTimeout(function(){
            document.dispatchEvent(new CustomEvent('validation-succes'));
            window.location.href = `/pages/diagnostic-resultats?email=${data.email}`;
          }, 3600);
        }
      });
    } else {
      console.log("Formulaire invalide")

    }
  })
})
